import {
  CLIENT_USAGE,
  CLIENT_BILLING,
  CLIENT_USERS,
} from 'constants/routes.js';
import { CLIENT_PERMISSIONS } from 'shared-permissions';
const {
  USAGE_CLIENT,
  BILLING_CLIENT,
  EDIT_USERS_CLIENT,
} = CLIENT_PERMISSIONS;

const CLIENT_ROUTES = [
  {
    title: 'Usage',
    icon: 'insights',
    route: CLIENT_USAGE,
    requiredPermission: USAGE_CLIENT,
    allowSuperAdmin: true,
  },
  {
    title: 'Billing',
    icon: 'storefront',
    route: CLIENT_BILLING,
    requiredPermission: BILLING_CLIENT,
    requiredFeatures: ['selfServeSubscriptionEnabled'],
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.settingsTitle',
    icon: 'settings',
    allowSuperAdmin: true,
    align: 'bottom',
    submenu: [
      {
        title: 'sidebarComponent.usersSettingsTitle',
        route: CLIENT_USERS,
        requiredPermission: EDIT_USERS_CLIENT,
        requiredFeatures: [],
        allowSuperAdmin: true,
      },
    ],
  },
];

export default CLIENT_ROUTES;
